import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";

const VIEWBOX = 100;
const CENTER = VIEWBOX / 2;

const RINGS = [
  { key: "grid", label: "Grid", radius: 40, stroke: 12 },
  { key: "solar", label: "Solar", radius: 26, stroke: 11 },
  { key: "storage", label: "Storage", radius: 13.5, stroke: 10 },
];

function isMissing(value) {
  return value === null || value === undefined || value === "" || Number.isNaN(Number(value));
}

function clampPercent(value) {
  return Math.max(0, Math.min(100, Number(value)));
}

function gaugeLabel(values, status) {
  if (status === "nodata") return "No Data";
  if (status === "error") return "Error";
  return RINGS.map((ring) => `${ring.label} ${Math.round(clampPercent(values[ring.key]))}%`).join(", ");
}

export default function PerformanceGauge({ grid, solar, storage, opacity = 1 }) {
  const values = { grid, solar, storage };
  const missingCount = RINGS.filter((ring) => isMissing(values[ring.key])).length;
  const status = missingCount === RINGS.length ? "nodata" : missingCount > 0 ? "error" : "gauge";

  return (
    <div
      className="performance-gauge"
      style={{ opacity }}
      role="img"
      aria-label={gaugeLabel(values, status)}
    >
      {status === "gauge" ? (
        <svg viewBox={`0 0 ${VIEWBOX} ${VIEWBOX}`} aria-hidden="true">
          {RINGS.map((ring) => {
            const percent = clampPercent(values[ring.key]);
            const circumference = 2 * Math.PI * ring.radius;
            const full = percent >= 100;
            return (
              <g key={ring.key}>
                <circle
                  className={`track ${ring.key}`}
                  cx={CENTER}
                  cy={CENTER}
                  r={ring.radius}
                  strokeWidth={ring.stroke}
                />
                {percent > 0 && (
                  <circle
                    className={`value ${ring.key}`}
                    cx={CENTER}
                    cy={CENTER}
                    r={ring.radius}
                    strokeWidth={ring.stroke}
                    strokeLinecap="round"
                    strokeDasharray={full ? undefined : `${(percent / 100) * circumference} ${circumference}`}
                    transform={`rotate(-90 ${CENTER} ${CENTER})`}
                  />
                )}
              </g>
            );
          })}
        </svg>
      ) : (
        <div className="performance-gauge__status" aria-hidden="true">
          <FontAwesomeIcon icon={faBan} />
          <span>{status === "nodata" ? "No Data" : "Error"}</span>
        </div>
      )}
    </div>
  );
}
